import {ExpandCollapse} from '@tds/core-expand-collapse';
import FlexGrid from '@tds/core-flex-grid';
import Select from '@tds/core-select';

import Button from '@tds/core-button';
import React, {useState} from 'react';
import PropTypes from 'prop-types';

import {useLocalizedStringsContext} from '../context/LocalizedStringsContext';
import {
    FILTER_BY_DEFECT_CATEGORY_OPTIONS, FILTER_BY_STATUS_OPTIONS, FILTER_BY_WEBFORM_OPTIONS, FILTERS_INIT_STATE
} from './constants';
import {Box} from '../design/css';

const Filters = ({onApplyFilters, onResetFilters}) => {
    const localizedStrings = useLocalizedStringsContext();
    const {
        DEFECT_MANAGEMENT: {
            FILTER = '', FILTER_BY_WEBFORM = {}, FILTER_BY_CATEGORY = {}, FILTER_BY_STATUS = {}, APPLY = '', RESET = ''
        } = {}
    } = localizedStrings;

    const [filter, setFilter] = useState({...FILTERS_INIT_STATE});

    return (<Box between={3}>
        <ExpandCollapse tag="h2">
            <ExpandCollapse.Panel id={FILTER} header={FILTER}>
                <Box between={1}>
                    <FlexGrid>
                        <FlexGrid.Row Style="margin-bottom:10px">
                            <FlexGrid.Col xs={12} md={4} lg={4} sm={12}>
                                <Select
                                    label={FILTER_BY_WEBFORM.title}
                                    placeholder={FILTER_BY_WEBFORM.placeholder}
                                    options={FILTER_BY_WEBFORM_OPTIONS.map(o => ({
                                        text: o, value: o
                                    }))}
                                    onChange={e => setFilter({...filter, defectWebform: e.target.value})}
                                    value={filter.defectWebform}
                                />
                            </FlexGrid.Col>
                            <FlexGrid.Col xs={12} md={4} lg={4} sm={12}>
                                <Select
                                    label={FILTER_BY_CATEGORY.title}
                                    placeholder={FILTER_BY_CATEGORY.placeholder}
                                    options={FILTER_BY_DEFECT_CATEGORY_OPTIONS.map(o => ({
                                        text: o, value: o
                                    }))}
                                    onChange={e => setFilter({
                                        ...filter, defectCategory: e.target.value
                                    })}
                                    value={filter.defectCategory}
                                />
                            </FlexGrid.Col>
                            <FlexGrid.Col xs={12} md={4} lg={4} sm={12}>
                                <Select
                                    label={FILTER_BY_STATUS.title}
                                    placeholder={FILTER_BY_STATUS.placeholder}
                                    options={FILTER_BY_STATUS_OPTIONS.map(o => ({
                                        text: o, value: o
                                    }))}
                                    onChange={e => setFilter({...filter, status: e.target.value})}
                                    value={filter.status}
                                />
                            </FlexGrid.Col>
                        </FlexGrid.Row>
                        <Box
                            display="flex"
                            justifyContent="center"
                            flexDirection="row"
                            pt={64}
                            mdJustifyContent="flex-start"
                            mdWidth={100}
                            mdPadding="16px 0"
                            margin="0 auto"
                        >
                            <Button variant="secondary" onClick={() => onApplyFilters(filter)}>{APPLY}</Button>
                            <Box width="2"> </Box>
                            <Button onClick={() => {
                                setFilter({...FILTERS_INIT_STATE});
                                onResetFilters(true);
                            }}>
                                {RESET}
                            </Button>
                        </Box>
                    </FlexGrid>
                </Box>
            </ExpandCollapse.Panel>
        </ExpandCollapse>
    </Box>);
};

Filters.propTypes = {
    onApplyFilters: PropTypes.func.isRequired,
    onResetFilters: PropTypes.func.isRequired
};
export default Filters;
